/* global common */
import {
  byUserInteraction, formatNumberLocale, sendAmplitudeEvent, sendRequest,
} from '@html/_common/utils';

export default function AOPaxMonthMenu(persistSelection) {
  this.common = {};
  if (typeof sendAmplitudeEvent !== 'undefined') {
    this.common = {
      byUserInteraction,
      sendAmplitudeEvent,
      sendRequest,
    };
  } else {
    this.common = common;
  }
  this.persistSelection = persistSelection;

  const SELECTOR_PAX_MONTH_MENU_MONTH_ITEM = '.js-ao-pax-month-menu__months-grid-month';
  const SELECTOR_PAX_MONTH_MENU_BLOCK = '.js-ao-pax-month-menu__selector-block';
  const SELECTOR_PAX_MONTH_YEAR_PEV_BTN = '.js-ao-pax-month-menu__year-control-prev';
  const SELECTOR_PAX_MONTH_YEAR_NEXT_BTN = '.js-ao-pax-month-menu__year-control-next';
  const SELECTOR_MAIN = 'main';

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  let activeYear = currentYear;

  function greyOutPastMonths() {
    // eslint-disable-next-line func-names
    $(SELECTOR_PAX_MONTH_MENU_BLOCK).each(function () {
      const yr = parseInt($(this).data('year'), 10);
      $(this)
        .find(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM)
        // eslint-disable-next-line func-names
        .each(function () {
          const $monthElement = $(this);
          $monthElement.removeClass('ao-pax-month-menu__months-grid-month--unavailable');
          const m = parseInt($monthElement.data('month'), 10);
          if (yr === currentYear && m < currentMonth) {
            $monthElement.addClass('ao-pax-month-menu__months-grid-month--unavailable');
          }
        });
    });
  }

  function updateView() {
    // eslint-disable-next-line func-names
    $(SELECTOR_PAX_MONTH_MENU_BLOCK).each(function () {
      $(this).toggleClass('ao-pax-month-menu__selector-block--active', parseInt($(this).data('year'), 10) === activeYear);
    });
  }

  const handlePrevButtonClick = () => {
    $(SELECTOR_PAX_MONTH_YEAR_PEV_BTN).on('click', () => {
      if (activeYear > currentYear) {
        activeYear -= 1;
        updateView();
      }
      $(SELECTOR_PAX_MONTH_YEAR_PEV_BTN).toggleClass('ao-pax-month-menu__selector-block-year-control-prev--disabled', activeYear === currentYear);
      $(SELECTOR_PAX_MONTH_YEAR_NEXT_BTN).toggleClass('ao-pax-month-menu__selector-block-year-control-next--disabled', activeYear === currentYear + 2);
    });
  };

  const handleNextButtonClick = () => {
    $(SELECTOR_PAX_MONTH_YEAR_NEXT_BTN).on('click', () => {
      if (activeYear < currentYear + 2) {
        activeYear += 1;
        updateView();
      }
      $(SELECTOR_PAX_MONTH_YEAR_PEV_BTN).toggleClass('ao-pax-month-menu__selector-block-year-control-prev--disabled', activeYear === currentYear);
      $(SELECTOR_PAX_MONTH_YEAR_NEXT_BTN).toggleClass('ao-pax-month-menu__selector-block-year-control-next--disabled', activeYear === currentYear + 2);
    });
  };

  const sendAmplitudeData = (year, month, $monthElement) => {
    const dataPlacement = $monthElement.closest('.js-ao-pax-month').attr('data-placement') || $('.js-ao-pax-month-sheet').attr('data-placement');
    const eventName = $monthElement.closest('.js-ao-pax-month').attr('data-event-name') || $('.js-ao-pax-month-sheet').attr('data-event-name');

    this.common.sendAmplitudeEvent({
      ampEventName: eventName,
      selected_date: `${year}-${month}`,
      click_source: dataPlacement,
    });
  };

  const persistSelected = (month, year) => {
    if (this.persistSelection) {
      document.cookie = `pax_month_year=${month}-${year}; path=/; expires=${new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toUTCString()}`;
    }
  };

  const handleMonthSelection = () => {
    // eslint-disable-next-line func-names
    $(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM).on('click', function () {
      const $monthElement = $(this);

      if ($monthElement.hasClass('ao-pax-month-menu__months-grid-month--unavailable')) {
        return;
      }

      const month = $monthElement.attr('data-month');
      const monthName = $monthElement.attr('data-month-name');
      const year = $monthElement.closest(SELECTOR_PAX_MONTH_MENU_BLOCK).attr('data-year');

      $(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM).removeClass('ao-pax-month-menu__months-grid-month--selected');
      $monthElement.addClass('ao-pax-month-menu__months-grid-month--selected');
      $(`.js-ao-pax-month-menu-month-${month}-${year}`).addClass('ao-pax-month-menu__months-grid-month--selected');

      $(document).trigger('paxSelection:monthChange', { monthName, month, year });
      persistSelected(month, year);

      sendAmplitudeData(year, month, $monthElement);
    });
  };

  const checkMonthsCookies = () => {
    const cookie = document.cookie.split('; ').find((row) => row.startsWith('pax_month_year='));
    if (cookie) {
      const [month, year] = cookie.split('=')[1].split('-');
      const parsedYear = Number.isNaN(parseInt(year, 10)) ? null : parseInt(year, 10);
      const parsedMonth = Number.isNaN(parseInt(month, 10)) ? null : parseInt(month, 10);

      // Check if the month is a past month
      if (parsedYear === null
        || parsedMonth === null
        || parsedYear < currentYear
        || (parsedYear === currentYear && parsedMonth < currentMonth)) {
        return;
      }

      activeYear = parsedYear;
      updateView();

      // eslint-disable-next-line func-names
      $(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM).each(function () {
        const $monthElement = $(this);
        if ($monthElement.attr('data-month') === month && $monthElement.closest(SELECTOR_PAX_MONTH_MENU_BLOCK).attr('data-year') === year) {
          $monthElement.addClass('ao-pax-month-menu__months-grid-month--selected');
          const monthName = $monthElement.attr('data-month-name');
          const monthNumber = $monthElement.attr('data-month');
          $(document).trigger('paxSelection:monthChange', { monthName, month: monthNumber, year });
        }
      });

      $(SELECTOR_PAX_MONTH_YEAR_PEV_BTN).toggleClass('ao-pax-month-menu__selector-block-year-control-prev--disabled', activeYear === currentYear);
      $(SELECTOR_PAX_MONTH_YEAR_NEXT_BTN).toggleClass('ao-pax-month-menu__selector-block-year-control-next--disabled', activeYear === currentYear + 2);
    }
  };

  const checkPageMonthData = (whereData) => {
    const [month, year] = whereData.split('-');
    const parsedYear = Number.isNaN(parseInt(year, 10)) ? null : parseInt(year, 10);
    const parsedMonth = Number.isNaN(parseInt(month, 10)) ? null : parseInt(month, 10);

    if (parsedYear === null
      || parsedMonth === null
      || parsedYear < currentYear
      || (parsedYear === currentYear && parsedMonth < currentMonth)) {
      return;
    }

    activeYear = parsedYear;
    updateView();

    // eslint-disable-next-line func-names
    $(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM).each(function () {
      const $monthElement = $(this);
      if ($monthElement.attr('data-month') === month && $monthElement.closest(SELECTOR_PAX_MONTH_MENU_BLOCK).attr('data-year') === year) {
        $monthElement.addClass('ao-pax-month-menu__months-grid-month--selected');
        const monthName = $monthElement.attr('data-month-name');
        const monthNumber = $monthElement.attr('data-month');
        $(document).trigger('paxSelection:monthChange', { monthName, month: monthNumber, year });
      }
    });

    $(SELECTOR_PAX_MONTH_YEAR_PEV_BTN).toggleClass('ao-pax-month-menu__selector-block-year-control-prev--disabled', activeYear === currentYear);
    $(SELECTOR_PAX_MONTH_YEAR_NEXT_BTN).toggleClass('ao-pax-month-menu__selector-block-year-control-next--disabled', activeYear === currentYear + 2);
  };

  const formatPrice = (price, currency) => {
    const numericPrice = parseFloat(price);
    const currencySymbols = {
      EUR: '€',
      USD: '$',
      GBP: '£',
      CAD: 'C$',
      AUD: 'A$',
    };

    const symbol = currencySymbols[currency] || currency;

    // Format with thousands separator, no decimal places
    const formattedNumber = formatNumberLocale(numericPrice, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    return `${symbol}${formattedNumber}`;
  };

  const updateMonthPrices = (pricesData) => {
    // eslint-disable-next-line func-names
    $(SELECTOR_PAX_MONTH_MENU_MONTH_ITEM).each(function () {
      const $monthElement = $(this);

      // Skip if month element is inside sticky component or search
      if ($monthElement.closest('.ao-header-pax-selector__sticky-component--when, .ao-header-pax-selector__search').length > 0) {
        return;
      }

      const $priceElement = $monthElement.find('.js-ao-pax-month-menu__months-grid-month-price');
      const month = parseInt($monthElement.attr('data-month'), 10);
      const year = parseInt($monthElement.closest(SELECTOR_PAX_MONTH_MENU_BLOCK).attr('data-year'), 10);

      // Check if this month has already passed - if so, don't add prices
      if (year < currentYear || (year === currentYear && month < currentMonth)) {
        $priceElement.empty();
        return;
      }

      // Create date key in YYYY-MM-DD format (using 1st day of month)
      const dateKey = `${year}-${month.toString().padStart(2, '0')}-01`;

      if (pricesData[dateKey]) {
        const priceData = pricesData[dateKey];

        // Clear existing content
        $priceElement.empty();

        // Check if price is null - if so, allow selection but don't show price
        if (priceData.price === null) {
          $priceElement.addClass('hid');
        } else {
          // Format price with currency
          const formattedPrice = formatPrice(priceData.price, priceData.currency);

          // Handle discount
          if (parseFloat(priceData.discount) > 0) {
            // Show discounted price with discounted styling
            $priceElement.text(formattedPrice);
            $priceElement.addClass('ao-pax-month-menu__months-grid-month-price--discounted');
          } else {
            // No discount - just show regular price
            $priceElement.text(formattedPrice);
            $priceElement.removeClass('ao-pax-month-menu__months-grid-month-price--discounted');
          }

          // Show the price element
          $priceElement.removeClass('hid');
        }
      } else {
        $monthElement.addClass('ao-pax-month-menu__months-grid-month--unavailable');
      }
    });
  };

  const fetchMonthFromPrices = () => {
    const pageType = $(SELECTOR_MAIN).attr('data-page-type');
    const pageId = $(SELECTOR_MAIN).attr('data-id');
    if (pageType === 'TDP' && pageId) {
      this.common.sendRequest(
        `/api/tdp/best-price/all-months-prices/${pageId}`,
        null,
        (data) => {
          if (data && Object.keys(data).length > 0) {
            updateMonthPrices(data);
          }
        },
        { type: 'GET' },
      );
    }
  };

  this.initiate = () => {
    if ($('main').data('when')) {
      checkPageMonthData($('main').data('when'));
    } else {
      checkMonthsCookies();
    }
    greyOutPastMonths();
    handlePrevButtonClick();
    handleNextButtonClick();
    handleMonthSelection();
    this.common.byUserInteraction('fetch-from-prices', fetchMonthFromPrices);
  };
}
